<template>
  <main-card
    v-if="item"
    :id="item._id"
    :item="item"
    :preview="item.asset.png"
    :subtitle="item.externalId"
    :title="item.name"
    :deletable="deletable"
    :status="item.status"
    :dense="dense"
    @delete="deleteSlide"
  />
</template>

<script>
import MainCard from '@/components/cards/main-card';

export default {
  components: {
    MainCard
  },
  props: {
    item: {
      type: Object,
      required: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean
    }
  },
  methods: {
    deleteSlide(item) {
      this.$emit('delete', item);
    }
  }
};
</script>
